import { useNavigate } from 'react-router-dom'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface SubmitCancelButtonsProps {
  submitDisabled: boolean
  submitForm: () => void
}

const SubmitCancelButtons = ({ submitDisabled, submitForm }: SubmitCancelButtonsProps) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const cardsListUrl = navigation.finance.cards.fullPath()

  return (
    <Box
      paddingX={'s140'}
      paddingBottom="s64"
      flexDirection="row"
      justifyContent="flexEnd"
      gap={'s8'}
      width="full"
    >
      <Button onClick={() => navigate(cardsListUrl)} type={'secondary'}>
        {i18n.t('expenses_v2.cards.form.cancel')}
      </Button>
      <Button disabled={submitDisabled} onClick={submitForm}>
        {i18n.t('expenses_v2.buttons.create_card')}
      </Button>
    </Box>
  )
}
export default SubmitCancelButtons
